function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Postage component
 * 
 */
import * as React from 'react';
import { IMAGE_PATH_PREFIX, FIELDS, POSTAGE, STARSHIPIT, DELIVERY_METHOD_PICK_UP_IN_STORE } from '../../../data/Data';
import Info from '../../../components/info/Info';
import RadioButton from '../../../components/radio-button/RadioButton';
import { connect } from 'react-redux';
import { postage } from '../../../actions';
import './Postage.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Postage extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Get StarShipIt rates for international delivery
     */
    _defineProperty(this, "getStarShipIt", () => {
      const {
        addresses,
        jest,
        setCanPay
      } = this.props;
      const {
        licenceDelivery,
        licenceDeliveryAddressStreet,
        licenceDeliveryAddressLocality,
        licenceDeliveryAddressState,
        licenceDeliveryAddressCountry,
        licenceDeliveryAddressPostcode
      } = addresses;
      switch (true) {
        case jest:
        case licenceDelivery === 'Australian':
          return null;
        case licenceDeliveryAddressStreet.value === '':
          console.warn('Skipping StarShipIt lookup. Missing delivery street');
          return null;
        case licenceDeliveryAddressCountry.value === '':
          console.warn('Skipping StarShipIt lookup. Missing delivery country');
          return null;
        default:
        // no op
      }
      let vars = {};
      let queryVars = '?';
      vars.street = licenceDeliveryAddressStreet.value;
      vars.country_code = licenceDeliveryAddressCountry.value;
      vars.post_code = licenceDeliveryAddressPostcode.required ? licenceDeliveryAddressPostcode.value : '00000';
      vars.weight = 0.5;
      if (licenceDeliveryAddressLocality.value) {
        vars.city = licenceDeliveryAddressLocality.value;
      }
      if (licenceDeliveryAddressState.required) {
        vars.state = licenceDeliveryAddressState.value;
      }
      for (const key in vars) {
        const join = key === 'street' ? '' : '&';
        queryVars = `${queryVars}${join}${key}=${vars[key]}`;
      }

      // Substitute `#` for `%23` as Starship returns 404 otherwise
      const pound = new RegExp('#', 'ig');
      queryVars = queryVars.replace(pound, '%23');
      const url = encodeURI(`${STARSHIPIT.url}${queryVars}`);
      const options = {
        method: 'GET',
        // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'StarShipIT-Api-Key': STARSHIPIT.apiKey,
          'Ocp-Apim-Subscription-Key': STARSHIPIT.primaryKey
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
        data: '{body}'
      };
      fetch(url, options).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(response => {
        this.success(response, url);
        setCanPay(true);
      }).catch(error => {
        this.error(error, url);
        setCanPay(true);
      });
      return url;
    });
    /**
     * Success StarShipit
     */
    _defineProperty(this, "success", (response, url) => {
      // case: error, or success but no rates provided
      if (!response.success || !response.rates || response.rates.length === 0) {
        const error = new Error(`Error fetching starShipIt rates with ${url} response: ${JSON.stringify(response)}`);
        this.error(error, url);
        return;
      }
      let {
        rates
      } = this.state;
      for (let i = 0; i < response.rates.length; i++) {
        const rate = response.rates[i];
        const cost = Math.round(rate.total_price * 100 + Number.EPSILON) / 100;
        rates.push({
          value: 'dhl_express_international',
          description: rate.service_name,
          cost
        });
      }
      this.setState({
        rates
      });

      // set shipping to DHL
      this.setShipping(rates[rates.length - 1].value);
    });
    /**
     * Error on starship it API
     */
    _defineProperty(this, "error", (error, url) => {
      let {
        rates
      } = this.state;
      console.warn(error, url);

      // dispatch to BugSnag
      this.props.bugsnagClient.notify(error);

      // set shipping to AusPost international express
      this.setShipping(rates[1].value);
    });
    /**
     * Get shipping
     */
    _defineProperty(this, "getShipping", () => {
      const {
        addresses,
        postage
      } = this.props;
      const {
        licenceDelivery
      } = addresses;
      let {
        value
      } = postage;
      const {
        rates
      } = this.state;
      for (let i = 0; i < rates.length; i++) {
        const rate = rates[i];
        if (rate.value === value) {
          return rate;
        }
      }

      // Fall back
      if (licenceDelivery === 'International') {
        return rates[1];
      }
      return rates[0];
    });
    /**
     * setShipping
     * only runs for international
     */
    _defineProperty(this, "setShipping", value => {
      const {
        setPostage
      } = this.props;
      const rate = this.getRate(value);
      setPostage(rate);
    });
    /**
     * getRate
     */
    _defineProperty(this, "getRate", value => {
      const {
        rates
      } = this.state;
      for (let i = 0; i < rates.length; i++) {
        const rate = rates[i];
        if (value === rate.value) {
          return rate;
        }
      }
      return rates[1]; // defaults to 'express_int'
    });
    _defineProperty(this, "renderDomesticOptions", () => {
      const {
        postage
      } = this.props;
      const {
        value
      } = postage;
      const {
        rates
      } = this.state;
      const options = [];

      // Filter to domestic shipping options only
      const domesticRates = rates.filter(rate => rate.value === 'express_post' || rate.value === 'registered_post');
      for (let i = 0; i < domesticRates.length; i++) {
        const rate = domesticRates[i];
        const checked = value === rate.value;
        const title = /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "description",
            children: rate.description
          }), /*#__PURE__*/_jsxs("div", {
            className: "price",
            children: [/*#__PURE__*/_jsx("span", {
              children: "AUD"
            }), " ", /*#__PURE__*/_jsxs("span", {
              children: ["$", rate.cost?.toFixed(2) ?? '0.00']
            })]
          })]
        });
        const icon = /*#__PURE__*/_jsx("img", {
          src: `${IMAGE_PATH_PREFIX}AustraliaPost_2019-hori.png`,
          alt: "Australia Post logo"
        });
        options.push({
          default: rate.value === 'express_post',
          checked,
          title,
          value: rate.value,
          icon
        });
      }
      return /*#__PURE__*/_jsx("div", {
        className: "Postage",
        children: /*#__PURE__*/_jsx(RadioButton, {
          label: "Please select your preferred Shipping",
          name: "postage",
          handleChange: this.setShipping,
          onBlur: this.setShipping,
          options: options
          // $FlowFixMe
          ,
          values: {
            postage
          }
        })
      });
    });
    _defineProperty(this, "renderInternationalOptions", () => {
      const {
        postage
      } = this.props;
      const {
        value
      } = postage;
      const {
        rates
      } = this.state;
      const options = [];

      // Start loop from 1 to exclude domestic post, and filter out pick_up and registered_post
      for (let i = 1; i < rates.length; i++) {
        const rate = rates[i];
        // Exclude options with $0 cost (in-store pickup) and domestic-only options
        if (rate.cost && rate.cost > 0 && rate.value !== 'registered_post') {
          const checked = value === rate.value;
          const title = /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: "description",
              children: rate.description
            }), /*#__PURE__*/_jsxs("div", {
              className: "price",
              children: [/*#__PURE__*/_jsx("span", {
                children: "AUD"
              }), " ", /*#__PURE__*/_jsxs("span", {
                children: ["$", rate.cost?.toFixed(2) ?? '0.00']
              })]
            })]
          });
          const icon = rate.value === 'express_international' ? /*#__PURE__*/_jsx("img", {
            src: `${IMAGE_PATH_PREFIX}AustraliaPost_2019-hori.png`,
            alt: "Australia Post logo"
          }) : /*#__PURE__*/_jsx("img", {
            src: `${IMAGE_PATH_PREFIX}DHL_Logo.svg`,
            alt: "DHL logo"
          });
          options.push({
            default: rate.value === 'express_international',
            checked,
            title,
            value: rate.value,
            icon
          });
        }
      }

      // Reverse to show DHL first (if available)
      options.reverse();
      return /*#__PURE__*/_jsxs("div", {
        className: "Postage",
        children: [/*#__PURE__*/_jsx(RadioButton, {
          label: "Please select your preferred International Shipping",
          name: "postage",
          handleChange: this.setShipping,
          onBlur: this.setShipping,
          options: options
          // $FlowFixMe
          ,
          values: {
            postage
          }
        }), value === 'express_international' && /*#__PURE__*/_jsx(Info, {
          icon: "circle-info",
          framed: true,
          info: "<strong>Note:</strong> Some countries do not accept express postal delivery for letters. Please check <a href=\"https://auspost.com.au/sending/delivery-speeds-and-coverage/international-delivery-times\" target=\"_blank\" rel=\"nofollow noreferrer\">Australia Post international delivery coverage, disruptions and timeframes</a> before selecting this option."
        })]
      });
    });
    this.state = {
      rates: [...POSTAGE]
    };
  }
  componentDidMount() {
    this.getStarShipIt();
  }
  render() {
    const {
      addresses,
      deliveryMethod
    } = this.props;

    // Don't display for in-store pickup
    if (deliveryMethod?.value === DELIVERY_METHOD_PICK_UP_IN_STORE.value) return null;

    // Render domestic options for Australian delivery
    if (addresses.licenceDelivery === 'Australian') {
      return this.renderDomesticOptions();
    }

    // Render international options
    return this.renderInternationalOptions();
  }
}
_defineProperty(Postage, "defaultProps", {
  addresses: {
    ...FIELDS.addresses,
    licenceDelivery: 'International'
  },
  deliveryMethod: {
    value: ''
  },
  jest: false,
  postage: {
    value: 'express_au',
    description: 'Express Post within Australia',
    cost: 11.75
  }
});
const mapStateToProps = ({
  addresses,
  deliveryMethod,
  postage
}) => {
  return {
    addresses,
    deliveryMethod,
    postage
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setPostage: value => {
      dispatch(postage(value));
    }
  };
};
const VisiblePostage = connect(mapStateToProps, mapDispatchToProps)(Postage);
export default VisiblePostage;